var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.50008H2.91667C2.41558 2.50008 1.94133 2.28308 1.61292 1.91733C1.93375 1.55916 2.39983 1.33341 2.91667 1.33341H13.4167C14.1797 1.32991 14.1791 0.169665 13.4167 0.166748H2.91667C1.30608 0.166748 0 1.47283 0 3.08342V8.91675C0 10.5273 1.30608 11.8334 2.91667 11.8334H12.25C13.2166 11.8334 14 11.05 14 10.0834V4.25008C14 3.2835 13.2166 2.50008 12.25 2.50008ZM11.6667 7.75008C10.9037 7.74658 10.9037 6.58692 11.6667 6.58342C12.4297 6.58692 12.4297 7.74658 11.6667 7.75008Z",
    fill: "#99A7C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.ba338024ce9e5118b53f0b7a21bdddd7.svg";
export { ForwardRef as ReactComponent };